import { render, staticRenderFns } from "./UserListAdmin.vue?vue&type=template&id=4ae13bea&scoped=true"
import script from "./UserListAdmin.vue?vue&type=script&lang=js"
export * from "./UserListAdmin.vue?vue&type=script&lang=js"
import style0 from "./UserListAdmin.vue?vue&type=style&index=0&id=4ae13bea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae13bea",
  null
  
)

export default component.exports